export default __webpack_public_path__ + "static/media/watson-3.f009dbe8.png";